<div id="spinner" [style.color]="color"></div>